import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgCircleLockIcon = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 82 82"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <g filter="url(#circleLockIcon_svg__a)">
            <rect width={64} height={64} x={9} y={9} fill="#fff" rx={32} />
        </g>
        <path
            fill="#F47321"
            fillRule="evenodd"
            d="M29.143 56.06q.94.94 2.26.94h19.2q1.32 0 2.26-.94t.94-2.26v-16q0-1.32-.94-2.26a3.08 3.08 0 0 0-2.26-.94h-1.6v-3.2q0-3.32-2.34-5.66t-5.66-2.34-5.66 2.34-2.34 5.66v3.2h-1.6q-1.32 0-2.26.94a3.08 3.08 0 0 0-.94 2.26v16q0 1.32.94 2.26m16.66-24.66v3.2h-9.6v-3.2q0-2 1.4-3.4t3.4-1.4 3.4 1.4 1.4 3.4m-4.8 19.201q1.98 0 3.39-1.41t1.41-3.39-1.41-3.39-3.39-1.41-3.39 1.41-1.41 3.39 1.41 3.39 3.39 1.41"
            clipRule="evenodd"
        />
        <defs>
            <filter
                id="circleLockIcon_svg__a"
                width={82}
                height={82}
                x={0}
                y={0}
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset />
                <feGaussianBlur stdDeviation={4.5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix values="0 0 0 0 0.188235 0 0 0 0 0.415686 0 0 0 0 0.568627 0 0 0 0.43 0" />
                <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_12299_58108"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_12299_58108"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
)
const ForwardRef = forwardRef(SvgCircleLockIcon)
const Memo = memo(ForwardRef)
export default Memo
